/* eslint-disable react/no-array-index-key */
import React from 'react';
import { useTranslation } from 'react-i18next';
import AccordionPanel from '@/components/UI/AccordionPanel/AccordionPanel';
import { IcoButtonSimple } from '@/components/UI/IcoButton/IcoButton';
import InputText from '@/components/UI/InputText/InputText';
import useCheckDisabled from '@/hooks/useCheckDisabled';
import { useFieldSelection } from '@/hooks/useFieldSelection';
import styles from './Notes.module.scss';

interface NotesProps {
  notes: string[];
  handleChangeText?: (text: string, index: number) => void; // eslint-disable-line no-unused-vars
  addNotes?: () => void;
  isMandatory?: boolean;
  invalid?: boolean;
  tab?: string;
}

const Notes = (props: NotesProps) => {
  const { notes, handleChangeText = () => { }, addNotes = () => { }, isMandatory = false, invalid = false, tab } = props;
  const { t } = useTranslation();
  const isDisabled = useCheckDisabled(true, true);
  const { isSelectionModeOn } = useFieldSelection({ tab });

  if (isSelectionModeOn) return null;

  return (
    <AccordionPanel
      title={t('notes.notes')}
    >
      <div className={styles.Add}>
        <div className={styles.Comments}>
          <IcoButtonSimple
            id="btn-add-notes"
            icon="icon-plus-hinzufuegen-klein"
            handleClick={addNotes}
            disabled={isDisabled}
          />
          <span className={styles.Notes}>{t('notes.addNotes')}</span>
        </div>
      </div>
      {notes?.map((note: string, index: number) => (
        <div key={index} className={styles.TwoColumns}>
          <InputText
            invalid={invalid}
            isMandatory={isMandatory}
            disabled={isDisabled}
            key={index}
            fieldPath={['allModulesNotes', `notes[${index}]`]}
            multiline
            rows={4}
            maxLength={512}
            id={`subCR-Notes-${index}`}
            label={`${t('notes.comments')} ${index + 1}`}
            handleChange={(ev) => handleChangeText(ev.target.value, index)}
            value={note}
            helperText={[
              ...(note?.length === 512
                ? [t('validations.maxLength', { maxLength: 512 })]
                : []),
            ]}
          />
        </div>
      ))}
    </AccordionPanel>
  );
};

export default Notes;
